import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function getTodayDate() {
  return new Date().toISOString().split('T')[0];
}

export function getStatusColor(status) {
  const colors = {
    healthy: 'text-[#32D74B]',
    injured: 'text-[#FF3B30]',
    recovering: 'text-[#FFD60A]',
    present: 'text-[#32D74B]',
    absent: 'text-[#FF3B30]',
    excused: 'text-[#007AFF]',
    new: 'text-[#FF3B30]',
    rehab: 'text-[#FFD60A]',
    cleared: 'text-[#32D74B]',
  };
  return colors[status] || 'text-[#A1A1AA]';
}

export function getStatusBgColor(status) {
  const colors = {
    healthy: 'bg-[#32D74B]/10 border-[#32D74B]/30',
    injured: 'bg-[#FF3B30]/10 border-[#FF3B30]/30',
    recovering: 'bg-[#FFD60A]/10 border-[#FFD60A]/30',
    present: 'bg-[#32D74B]/10 border-[#32D74B]/30',
    absent: 'bg-[#FF3B30]/10 border-[#FF3B30]/30',
    excused: 'bg-[#007AFF]/10 border-[#007AFF]/30',
    new: 'bg-[#FF3B30]/10 border-[#FF3B30]/30',
    rehab: 'bg-[#FFD60A]/10 border-[#FFD60A]/30',
    cleared: 'bg-[#32D74B]/10 border-[#32D74B]/30',
    mild: 'bg-[#32D74B]/10 border-[#32D74B]/30',
    moderate: 'bg-[#FFD60A]/10 border-[#FFD60A]/30',
    severe: 'bg-[#FF3B30]/10 border-[#FF3B30]/30',
  };
  return colors[status] || 'bg-[#27272A] border-[#3F3F46]';
}
